import { render, staticRenderFns } from "./AssetclassSimple.vue?vue&type=template&id=bc3cb086&"
import script from "./AssetclassSimple.vue?vue&type=script&lang=js&"
export * from "./AssetclassSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports